import IDS from '../constants/IDS';
import { SIDE_BAR_POSITION, TSideBarPosition } from '../types/sideBar';
import { SWIPE_DIRECTION, TSwipeDirection } from '../types/swipe';
import { getBoundingClientRect } from './coordinates';

export const getNewSideBarPosition = (
  swipeDirection: TSwipeDirection,
  currentPosition: TSideBarPosition,
  isDoubleMove: boolean,
) => {
  if (swipeDirection === SWIPE_DIRECTION.LEFT || swipeDirection === SWIPE_DIRECTION.RIGHT) {
    return null;
  }

  if (swipeDirection === SWIPE_DIRECTION.UP) {
    if (currentPosition === SIDE_BAR_POSITION.BOTTOM) {
      return isDoubleMove ? SIDE_BAR_POSITION.TOP : SIDE_BAR_POSITION.MIDDLE;
    }

    if (currentPosition === SIDE_BAR_POSITION.MIDDLE) {
      return SIDE_BAR_POSITION.TOP;
    }
  }

  if (swipeDirection === SWIPE_DIRECTION.DOWN) {
    if (currentPosition === SIDE_BAR_POSITION.TOP) {
      return isDoubleMove ? SIDE_BAR_POSITION.BOTTOM : SIDE_BAR_POSITION.MIDDLE;
    }

    if (currentPosition === SIDE_BAR_POSITION.MIDDLE) {
      return SIDE_BAR_POSITION.BOTTOM;
    }
  }
};

export const isMobileLayout = () => {
  const root = document.getElementById(IDS.rootLayout);

  return getBoundingClientRect(root).width < 768;
};
